import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=5eff312d&scoped=true&"
import script from "./index copy.vue?vue&type=script&lang=js&"
export * from "./index copy.vue?vue&type=script&lang=js&"
import style0 from "./index copy.vue?vue&type=style&index=0&id=5eff312d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eff312d",
  null
  
)

export default component.exports